import { Box } from '@mui/material'
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  Tooltip,
} from 'chart.js'
import chartTrendline from 'chartjs-plugin-trendline'
ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  chartTrendline,
  Tooltip
)

export const Dashboard = () => {
  return (
    <Box
      sx={{ padding: '24px', maxWidth: '1184px', marginInline: 'auto' }}
    ></Box>
  )
}
